<template>
  <app-modal class="yield-goal-create" @close="close">
    <app-modal-filled @close="close">
      <div class="content">
        <app-text-input
          class="goal"
          styling="inline-inverse"
          v-model="data.goal"
          label="Goal"
          type="number"
          :hint="$store.getters['unit/getLabel']('t/ha')"
          min="0"
          max="9999999"
          step="0.01"
          :digits-after-dot="2"
        />
        <!-- <app-text-input
          styling="inline-inverse"
          v-model="data.comment"
          label="Comment"
        /> -->
        <app-btn
          :loading="loading"
          @click="create"
        >{{ $ml.get(`save`) }}</app-btn>
      </div>
    </app-modal-filled>
  </app-modal>
</template>

<script>
import { CropAPI } from '@/api'
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      data: {
        goal: null,
        comment: '',
      },
      err: {
        goal: false,
        comment: false,
      },
    }
  },

  computed: {
    ...mapGetters({
      parent: 'crop/method',
    })
  },

  methods: {
    create() {

      if(!this.data.goal) {
        this.$notify({
          group: 'notices',
          title: 'Please enter goal',
          type: 'error',
        });
        return;
      }

      this.loading = true;
      const goal = this.$store.getters['unit/unConvert']('t/ha', this.data.goal);
      
      return CropAPI.createYieldGoal({
        goal,
        methodId: this.parent.id,
        comment: this.data.comment,
      }).then(res => {
        this.updateParentList(res.data);
      }).finally(res => {
        this.loading = false;
        this.close();
      });
    },

    updateParentList(item = null) {
      this.$emit('update', item);
    },
    close() {
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>

.yield-goal-create {
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .app-text-input {
    margin-right: 10px;
    flex-grow: 1;
    width: unset;
  }

  .goal {
    width: 100px;
  }
}

</style>
